<script lang="ts">
  import { getContext } from 'svelte'
  import { twMerge } from 'tailwind-merge'

  interface BaseProps {
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
    role?: string
    class?: string
  }

  const ctx: BaseProps = getContext('iconCtx') ?? {}
  const sizes = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
    xl: 'w-8 h-8',
  }

  let {
    size = ctx.size || 'md',
    role = ctx.role || 'img',
    class: className = '',
    ariaLabel = 'BookWalker',
    ...rest
  }: BaseProps & { ariaLabel?: string } = $props()
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
  class={twMerge('shrink-0', sizes[size ?? 'md'], className)}
  {role}
  aria-label={ariaLabel}
  viewBox="0 0 48 48"
  fill="none"
>
  <path
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    d="M9.735 24.974v-12.5m4.221 12.5v-12.5m4.22 12.5v-12.5m4.221 12.5v-12.5m4.221 12.5v-12.5m4.22 12.5v-12.5m4.221 12.5v-12.5m4.22 12.5v-12.5m4.221 12.5v-12.5M4.5 24.76l3.235-12.073M24 27.591l-.985 3.031h-3.187l2.579 1.873l-.985 3.031L24 33.653l2.578 1.873l-.984-3.03l2.578-1.874h-3.187z"
  />
</svg>
